/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs */

const en_compare_event_groups_csv_group_b_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group B Start`)
};

const fr_compare_event_groups_csv_group_b_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début du groupe B`)
};

const de_compare_event_groups_csv_group_b_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe B Start`)
};

const it_compare_event_groups_csv_group_b_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio Gruppo B`)
};

const ru_compare_event_groups_csv_group_b_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Старт группы B`)
};

const es_compare_event_groups_csv_group_b_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio del Grupo B`)
};

const zh_cn2_compare_event_groups_csv_group_b_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B组开始`)
};

const ja_compare_event_groups_csv_group_b_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループBスタート`)
};

const hi_compare_event_groups_csv_group_b_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह बी प्रारंभ`)
};

const pt_pt2_compare_event_groups_csv_group_b_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início do Grupo B`)
};

/**
* | output |
* | --- |
* | "Group B Start" |
*
* @param {Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_b_start_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_B_Start_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_csv_group_b_start_header(inputs)
	if (locale === "de") return de_compare_event_groups_csv_group_b_start_header(inputs)
	if (locale === "it") return it_compare_event_groups_csv_group_b_start_header(inputs)
	if (locale === "ru") return ru_compare_event_groups_csv_group_b_start_header(inputs)
	if (locale === "es") return es_compare_event_groups_csv_group_b_start_header(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_csv_group_b_start_header(inputs)
	if (locale === "ja") return ja_compare_event_groups_csv_group_b_start_header(inputs)
	if (locale === "hi") return hi_compare_event_groups_csv_group_b_start_header(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_csv_group_b_start_header(inputs)
	return en_compare_event_groups_csv_group_b_start_header(inputs)
});